import { ReactNode } from "react";
import { IconImg } from "../../contents/Icons";
import { StyledCardSection } from "./style";

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {keyof IconImg} props.icon
 * @param {ReactNode} props.children
 */
export const CardSection = ({ title, icon, children }) => {
  const HeaderIcon = IconImg[icon];
  return (
    <StyledCardSection>
      <div className="card-section">
        <div className="title-box">
          <div className="wrap">
            <HeaderIcon />
            <p>{title}</p>
          </div>
        </div>
        <div className="content-box">{children}</div>
      </div>
    </StyledCardSection>
  );
};
